// extracted by mini-css-extract-plugin
export default {"btn-group":"ShareScreenBtnGroup_btn-group__yOh7+","selected":"ShareScreenBtnGroup_selected__idlZa","badge":"ShareScreenBtnGroup_badge__lcQOw"};